import './App.css';
import Login from './components/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Home from './components/Home';
import WishList from './components/WishList';
import { Provider, useSelector } from 'react-redux';
import { store } from './redux/store';
import RestaurantItemDetail from './components/RestaurantItemDetail/RestaurantItemDetail';
import Cart from './components/Cart/Cart';
import PaymentSuccessPage from './components/PaymentPage/PaymentSuccessPage';
import React from 'react';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
// import {BrowserRouter as Router, Routes, Route} from "react-router-dom"

function App() {
  const darkModeState = useSelector(state => state.darkModeReducer)
  console.log("🚀 ~ App ~ isDarkMode:", darkModeState.isDarkMode)

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`App ${darkModeState.isDarkMode ? "dark-mode" : "light-mode"}`}>
      <BrowserRouter>
        {/* {window.location.pathname != "/login" && <Header />} */}
        <Switch>
          <Route exact path="/" component={Login} />
          <ProtectedRoute exact path="/home" component={Home} />
          <ProtectedRoute exact path="/paymentSuccess" component={PaymentSuccessPage} />
          <ProtectedRoute exact path="/restaurantItem/:id" component={RestaurantItemDetail} />
          <ProtectedRoute exact path="/wishlist" component={WishList} />
          <ProtectedRoute exact path="/cart" component={Cart} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
